// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3v__M","requiredAsterisk":"Info_requiredAsterisk__yed02"};